import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { tap } from 'rxjs';
import { SnackbarComponent } from '../components/snackbar/snackbar.component';
import { INotification } from '../interfaces/INotification';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private _snackBar = inject(MatSnackBar);
  private notificationQueue: Array<{
    notification: INotification;
    data?: object;
    duration?: number;
  }> = [];
  private isProcessing = false;

  public showMessage(notification: INotification, data?: object, duration = 2000): void {
    // Add the new notification to the queue
    this.notificationQueue.push({ notification, data, duration });

    // If not already processing, start processing the queue
    if (!this.isProcessing) {
      this.processQueue();
    }
  }

  private processQueue(): void {
    // If queue is empty, reset processing flag
    if (this.notificationQueue.length === 0) {
      this.isProcessing = false;
      return;
    }

    // Set processing flag
    this.isProcessing = true;

    // Get the first notification from the queue
    const { notification, data, duration } = this.notificationQueue.shift();

    // Open the snackbar
    const snackBarRef = this._snackBar.openFromComponent(SnackbarComponent, {
      duration,
      data: {
        type: notification.type,
        title: notification.title,
        desc: notification.desc,
        parameters: data,
      },
    });

    // After this notification is dismissed, process the next one
    snackBarRef
      .afterDismissed()
      .pipe(tap(() => this.processQueue()))
      .subscribe();
  }
}
